import { Action } from '@ngrx/store';
import { Permission } from '@account-users/account/models/Permission';

export enum PermissionsActionTypes {
  LoadPermissions = '[Permissions] Load Permissions',
  LoadPermissionsSuccess = '[Permissions] Load Permissions LoadPermissions Success',
  LoadPermissionsFailed = '[Permissions] Load Permissions LoadPermissions Failed',
}

export class LoadPermissions implements Action {
  readonly type = PermissionsActionTypes.LoadPermissions;
}

export class LoadPermissionsSuccess implements Action {
  readonly type = PermissionsActionTypes.LoadPermissionsSuccess;
  constructor(public payload: Permission[]) {}
}

export class LoadPermissionsFailed implements Action {
  readonly type = PermissionsActionTypes.LoadPermissionsFailed;
}

export type PermissionsActions =
  | LoadPermissions
  | LoadPermissionsSuccess
  | LoadPermissionsFailed;
